import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../utilities/string'
import { Button } from './Button'

export interface LoadMoreButtonProps {
  additionalClassName?: string
  allContentButtonText?: string
  allContentUrl?: string
  currentNumItems: number
  numItemsPerPage: number
  loadMoreButtonText?: string
  onLoadMore?: (numItems: number) => void
  maxItems: number
}

export const LoadMoreButton = ({
  additionalClassName = '',
  allContentButtonText,
  allContentUrl,
  currentNumItems,
  numItemsPerPage,
  loadMoreButtonText = 'More',
  onLoadMore,
  maxItems,
}: LoadMoreButtonProps): JSX.Element => {
  const maxItemsReached = currentNumItems >= maxItems
  const hasAllContentLink =
    !isNullOrWhiteSpace(allContentUrl) && !isNullOrWhiteSpace(allContentButtonText)
  const showButton = !maxItemsReached || hasAllContentLink

  if (!showButton) {
    return <></>
  }

  return (
    <footer className={classNames('text-center', additionalClassName)}>
      {!maxItemsReached && (
        <Button onClick={() => onLoadMore?.(currentNumItems + numItemsPerPage)}>
          {loadMoreButtonText}
        </Button>
      )}

      {maxItemsReached && hasAllContentLink && (
        <Button url={allContentUrl}>{allContentButtonText}</Button>
      )}
    </footer>
  )
}
